<template>
  <div class="footer-container" ref="container">
    <div class="footer-position" ref="position">
      <div class="footer">
        <div class="footer-top">
          <div v-for="(value,index) in service" :key="index">
            <p>{{ value.name }}</p>
            <ul>
              <li v-for="(v,i) in value.children" :key="i" @click="toService(v.id)">{{ v.name }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="code">
          <a href="http://beian.miit.gov.cn" target="_blank">{{ companyNumber }}</a>
        </p>
        <p class="ydb">由亿店宝提供技术支持</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getXBBasicInformation,
  saveXBService,
  getXBService
} from "common/js/storage";
import XBHome from "models/xb/home.js";
import { setTimeout } from "timers";
const xbHome = new XBHome();
export default {
  data() {
    return {
      service: [],
      companyNumber: ""
    };
  },
  beforeMount() {
    this.getServeData();
    this.basicInformation();
  },
  mounted() {
    setTimeout(() => {
      this.$refs.container.style.height =
        this.$refs.position.clientHeight + "px";
    }, 500);
  },
  methods: {
    toService(id) {
      let routeUrl = this.$router.resolve({
        path: "/service",
        query: {
          id
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 获取底部数据
    getServeData() {
      if (!getXBService()) {
        xbHome.getXBbottom().then(res => {
          if (res.success) {
            let arr = [];
            res.result.map(value => {
              let obj = {};
              obj.name = value.name;
              obj.id = value.id;
              obj.children = [];
              value.bottomModuleInfos.map(v => {
                let object = {};
                object.name = v.title;
                object.id = v.id;
                obj.children.push(object);
              });
              arr.push(obj);
            });
            this.service = arr;
            saveXBService(this.service);
          }
        });
      } else {
        this.service = getXBService();
        console.log(2222);
        console.log(this.service);
      }
    },
    // 获取基础信息
    basicInformation() {
      if (getXBBasicInformation() === "") {
        setTimeout(() => {
          let res = getXBBasicInformation();
          this.companyNumber = res.companyNumber;
        }, 800);
      } else {
        let res = getXBBasicInformation();
        this.companyNumber = res.companyNumber;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.footer-container {
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  .footer-position {
    width: 100%;
    background: #303132;
    position: absolute;
    bottom: 0;
  }
  .footer {
    width: 1200px;
    margin: 0 auto;
    .footer-top {
      /* min-height: 160px; */
      padding: 20px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      > div {
        width: 192px;
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;
          margin-bottom: 8px;
        }
        ul {
          li {
            font-size: 12px;
            color: #a4a4a4;
            line-height: 20px;
            margin-bottom: 7px;
            text-align: center;
            cursor: pointer;
            font-family: "Microsoft YaHei";
          }
          li:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  .footer-bottom {
    border-top: 1px solid #c9caca;
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-size: 12px;
      color: #a4a4a4;
      line-height: 12px;
      padding: 0 10px;
    }
    .ydb {
      border-left: 1px solid #a4a4a4;
    }
    .code {
      cursor: pointer;
      a {
        color: #a4a4a4;
        outline: none;
      }
    }
  }
}
</style>
